(() => {
  TrackApp.impressions = (() => {
    const whenElementVisible = (element, threshold, repeat, callback) => {
      if (typeof IntersectionObserver === 'undefined') return;

      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= threshold) {
            if (!repeat) {
              intersectionObserver.unobserve(entry.target);
              intersectionObserver.disconnect();
            }
            callback();
          }
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.4,
      });

      intersectionObserver.observe(element);
    };

    const trackImpressions = (element, eventCategory, eventAction, eventLabel, options = {}) => {
      if (element === null) return;

      const settings = { threshold: 0.4, repeat: false, ...options };

      whenElementVisible(element, settings.threshold, settings.repeat, () => {
        TrackApp.trackInteraction(eventCategory, eventAction, eventLabel, 'gaEventNonInteraction');
      });
    };

    return {
      trackImpressions,
    };
  })();
})();
